import { api } from '@/services/http.service';
import { defineStore } from 'pinia';
import { CountryListItem } from '@/models/dictionary/country-list.model';
import { showErrorNotification } from '@/utils/show-notification.util';

interface CountryListState {
  countryList: CountryListItem[];
  isCountryListLoading: boolean;
}

export const useCountryListStore = defineStore('CountryListStore', {
  state: (): CountryListState => ({
    countryList: [],
    isCountryListLoading: false,
  }),
  actions: {
    setCountryListLoading(isLoading: boolean): void {
      this.isCountryListLoading = isLoading;
    },
    setCountryList(countryList: CountryListItem[]): void {
      this.countryList = countryList;
    },
    getCountryList(): Promise<CountryListItem[]> {
      if (this.countryList.length) {
        return Promise.resolve(this.countryList);
      }

      this.setCountryListLoading(true);

      return api.dictionary.getCountryListRequest.perform()
        .then((countryList: CountryListItem[]) => {
          this.setCountryList(countryList);

          return countryList;
        })
        .catch(error => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setCountryListLoading(false);
        });
    },
  },
});
